import {
  ProductEntity,
  ProductId,
  StoreLoading
} from '../types';
import {
  ProductsStoreState,
  ProductWithAnalytics
} from './types';

type ProductsSelectors = {
  selectLoading: (
    state: ProductsStoreState
  ) => StoreLoading;
  selectProducts: (
    state: ProductsStoreState
  ) => ProductEntity<ProductWithAnalytics>;
  selectProductsIds: (
    state: ProductsStoreState
  ) => ProductId[];
  selectHasProducts: (state: ProductsStoreState) => boolean;
};

export default {
  selectLoading: (state) => state.loading,

  selectProducts: (state) => state.entities,

  selectProductsIds: (state) => state.ids,

  selectHasProducts: (state) => state.ids?.length > 0
} as ProductsSelectors;
